import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import jenkins from "../../Assets/Projects/jenkins.png";
import visitEgypt from "../../Assets/Projects/visitEgypt.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={visitEgypt}
              isBlog={false}
              title="VisitEgypt"
              description="A gamified AR-based mobile application for the Egyptian tourism industry.A gamified AR-based mobile application for the Egyptian tourism industry.              "
              ghLink="https://github.com/visit-egypt/backend"
              demoLink="https://www.youtube.com/watch?v=6FlJzJAs15c"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={jenkins}
              isBlog={true}
              title="Jenkins high availability and scalabality on Kubernetes"
              description="Operating a Jenkins controller on a K8s cluster is the main method to put in place. So, Jenkins agents will auto-scale as K8s pods with custom docker images."
              ghLink="https://geekahmed.hashnode.dev/series/jenkins-on-k8s"
              demoLink="https://youtu.be/3IiEX8U7VCY"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
